// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__hwjTo","buttons":"RemoveExpirationActionButtons_buttons__5-dny"};